module.exports = __webpack_public_path__ + "img/61.b8ff2ab3.jpg";